import React, {useEffect, useState} from 'react';
import './categories.css';
import associateServices from "../../services";
import {useSelector} from "react-redux";
import {Link} from "react-router-dom";
import stringHelper from "../../helpers/string-helper";
import moment from "moment";
import NoData from "../../components/no-data";
import {useTranslation} from "react-i18next"; // Make sure to create and import the CSS file
import {LazyLoadImage} from "react-lazy-load-image-component";
import Loading from "../../components/loading";


const BlogCategories = () => {
    const {activeLanguage} = useSelector(state => state.globalReducer)
    const {t, i18n} = useTranslation()
    const currentLanguage = i18n.language; // Get the current language
    const [categories, setCategories] = useState([])
    const [activeCategoryID, setActiveCategoryID] = useState(null)

    const [loading, setLoading] = useState(true)
    const [firstItem, setFirstItem] = useState({})
    const [data, setData] = useState([])
    useEffect(() => {

        associateServices.getBlogCategories({
            lang: activeLanguage?.key
        }).then(res => {
            setCategories(res?.data)

            if (res?.data?.length >= 1)
                setActiveCategoryID(res?.data[0]?.id)
        })

    }, [activeLanguage?.key])


    useEffect(() => {

        if (activeCategoryID && activeLanguage?.key) {

            setLoading(true)

            if (!firstItem?.slug)
                associateServices.getBlogListTop({
                    lang: activeLanguage?.key,
                }).then(res => {
                    setFirstItem(res?.data || {})
                })


            associateServices.getBlogsByCategory({
                lang: activeLanguage?.key,
                category_id: activeCategoryID
            }).then(res => {
                setLoading(false)
                setData(res?.data || [])
            })
        }
    }, [activeLanguage?.key, activeCategoryID])

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="tab-content">
                        <div className="tab-pane fade show active">
                            {
                                firstItem?.slug &&
                                <Link
                                    to={stringHelper.getLocalizedPath(currentLanguage, `/blog/${firstItem.slug}`)}
                                    className="post post--big">
                                                  <span className="post__cover">
                                                      <LazyLoadImage
                                                          height={'100%'}
                                                          width={'100%'}
                                                          effect="blur"
                                                          threshold="100"
                                                          placeholderSrc={firstItem.image}
                                                          src={firstItem.image} alt=""/>
                                                  </span>
                                    <span className="post__content">
                                                    <span className="post__meta">
                                                      <span
                                                          className="post__date">{moment.unix(firstItem.timestamp).format("MMM D, YYYY")}</span>
                                                    </span>
                                                    <h2 className="post__title">
                                                        {firstItem.title}
                                                    </h2>
                                                    <p className="post__text">
                                                        {firstItem.description}
                                                    </p>
                                                  </span>
                                </Link>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="category-grid-wrapper">

                <div className="category-grid">
                    {categories.map((cat, idx) => (
                        <div
                            onClick={e => setActiveCategoryID(cat?.id)}
                            className={`category-tile ${cat.id === activeCategoryID ? 'active' : ''}`} key={idx}>
                            <div className="category-image">
                                <img src={cat.image} alt={cat.title}/>
                            </div>
                            <div className="category-info">
                                <span className="category-title">{cat.title}</span>
                                <span className="category-arrow">›</span>
                            </div>
                        </div>
                    ))}
                </div>

            </div>

            <div className="row">
                <div className="col-12">
                    <div className="tab-content">
                        <div className="tab-pane fade show active">
                            {
                                loading ? <Loading/> :
                                    data?.length <= 0 ?
                                        <NoData desc={t('blog.empty')}/> :

                                        <>

                                            <div className="blog-grid">
                                                {
                                                    data?.map(blog => (
                                                        <Link
                                                            key={blog?.slug}
                                                            to={stringHelper.getLocalizedPath(currentLanguage, `/blog/${blog.slug}`)}
                                                            className="post">

                                                                    <span className="post__cover">
                                                                      <LazyLoadImage
                                                                          height={'100%'}
                                                                          width={'100%'}
                                                                          effect="blur"
                                                                          threshold="100"
                                                                          src={blog.image}
                                                                          placeholderSrc={blog.image}
                                                                          alt=""/>
                                                                    </span>
                                                            <span className="post__meta">
                                                                            <span
                                                                                className="post__date">
                                                                            {moment.unix(blog.timestamp).format("MMM D, YYYY")}</span>
                                                                         </span>
                                                            <h2 className="post__title">
                                                                {blog.title}
                                                            </h2>
                                                            <p className="post__text">
                                                                {blog.description}
                                                            </p>
                                                        </Link>
                                                    ))
                                                }
                                            </div>

                                        </>

                            }
                        </div>
                    </div>
                </div>
            </div>


        </>
    );
};


export default BlogCategories;
